import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import saveAs from 'file-saver';
import { MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { GrievanceRemarks, VendorDetails } from 'src/app/models/vendor-details.model';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-grievance-handler',
  templateUrl: './grievance-handler.component.html',
  styleUrls: ['./grievance-handler.component.scss']
})
export class GrievanceHandlerComponent implements OnInit {
  @Input() finyear: string;
  
  @ViewChild('dataTable') tableContainer: ElementRef;

  public subActionType: string = "Grievance Handler";
  // public finYear: any;
  vendorCode:any;
  userType:any;
  public miTableData: any = [];
  public actionTypesFromTableData: any = [];
  public miCompletedFilterList: any = [];
  public subscriptions: any = [];
  public userId: any;
  isLoading:boolean;
  isSubmitted:boolean;
  // public selectedMICompletedFilter: null;
  public statusOptions = [
    { label: 'Active', value: 'Active' },
    { label: 'Closed', value: 'Closed' },
    // { label: 'Pending', value: 'Pending' }
  ];
  public displayDialog: boolean = false;
  public selectedData: any = {};
  public miTableDataWithFilter: any = [];
  public tableHeaderName = 'Grievance Handler';
  miCompletedReport: MenuItem[];
  loading: boolean;
popup:FormGroup;
  constructor(
    private reportsService: ReportsService,
    private formBuilder: FormBuilder,
    private router: Router, 
    private loader: AppLoaderService,
    private messageService: MessageService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    this.popup = this.formBuilder.group({
      ticket: [{ value: '', disabled: true }],
      description: ['', Validators.required],
      status: ['', Validators.required]

      });
    this.loadMIDataUnderProcess();
    // this.finYear = 'All';
    // if(this.finYear == 'All'){
    //   this.finYear = '';
    // }

    // this.loadMIDataUnderProcess(this.subActionType, 0);
    // setTimeout( () => this.tableContainer.nativeElement.scrollIntoView({
    //   block: "center",
    //   behavior: "smooth"
    // }), 400)
    
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    this.vendorCode=JSON.parse(sessionToken).officeCode

    this.miCompletedReport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.miTableDataWithFilter, `MI_${this.tableHeaderName}`);
        },
      },
    ];
  }
  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Tickect No': d.TicketNo,
          'User Type': d?.User_Id,
          'User': d?.User_Name,
          'Mobile No': d?.Mobile_No,
          'Email': d.EmailID,
          'Address': d.Address,
          'Grivence Type': d.GrievanceType,
          'Greievence Description': d.BriefDescription,
          'Date': d.Date,
          'Status': d.Status,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  loadMIDataUnderProcess() {
    // this.loader.start();
    // if (autoId == 0) {
    //   this.loading = true;
    // }
    let sub = this.reportsService
      .getGrievenceHandler()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.miTableDataWithFilter=data;
          // this.popup.value['ticket']=this.miCompletedFilterList.ticketNo;
          // this.popup.value['description']=this.miCompletedFilterList.remarks;
          // this.popup.value['status']=this.miCompletedFilterList.status;
          this.loading = false;
        },
        error: (err) => {
          // this.loading = false;
          // this.loading = false;
          // this.miTableData = [];
          // this.miTableDataWithFilter = [];
          // this.actionTypesFromTableData = [];
        },
      });

      this.subscriptions.push(sub);
  }

  
  updateGrievence(data:any){

  }
  openDialog(data: any) {
    this.selectedData = { ...data };
    this.popup.patchValue({
      ticket: data.TicketNo,
      description: null,
      status: data.Status
    });
    this.displayDialog = true;
  }
  // saveChanges() {
  //   // Here, you can perform any logic, like making an API call to update the grievance.
  //   console.log('Updated Data:', this.selectedData);
    
  //   // Call the service to update the data in the backend (if needed)
  //   // this.reportsService.updateGrievance(this.selectedData).subscribe(response => {
  //   //   // Handle response
  //   // });

  //   this.displayDialog = false; // Close the dialog
  // }
  getSeverity(status: any) {
    if (status.startsWith('A')) {
      return 'warning'
    } else if (status.startsWith('C')) {
      return 'success';
    }
  }
  mapDataToFarmersModel(): GrievanceRemarks {
    let farmerData = JSON.parse(window.sessionStorage.getItem('vendorDetails'));
    
    let data: GrievanceRemarks = {};
   
    data.ticketNo = this.popup.value['ticket'];
    data.remarks=this.popup.value['description'];
    data.status = this.popup.value['status'];
    
    return data;
  }
  _insert(data_) {
    this.reportsService.updateGrievence(data_).pipe(first())
      .subscribe({
        next: (data) => {
          
          this.isLoading = false;
         
            
          },
        error: (err) => {
          // this.loader.close();
          this.isLoading = false;
          // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Vendors Details not saved.' });
          // this.activityRecordService.activityRecord(phNo, 'Update Personal Details', '', new Date(), err, JSON.stringify(data_));
        }
      });
  }
  saveChanges() {
    if (this.popup.valid) {
      const formData = this.popup.getRawValue(); // Get form data including disabled fields
      const mappedData = this.mapDataToGrievanceModel(formData);

      this.loader.start();
      this.reportsService.updateGrievence(mappedData).pipe(first()).subscribe({
        next: () => {
          this.loader.close();
          this.displayDialog = false;
          this.messageService.add({ severity: 'success', 
              summary: 'Success Message', 
              detail: 'Status Updated successfully' 
            });

          this.loadMIDataUnderProcess(); // Reload the table data
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', 
            summary: 'Error Message', 
            detail: err 
          });
          this.loader.close();
          console.error('Error updating grievance:', err);
        }
      });
    }else{
      this.messageService.add({ severity: 'info', 
        summary: 'Info Message', 
        detail: 'Add Remarks' 
      });
    }
  }
  mapDataToGrievanceModel(formData: any): GrievanceRemarks {
    return {
      ticketNo: formData.ticket,
      remarks: formData.description,
      status: formData.status.value
    };
  }

  hideDialog(){
    this.displayDialog = false;
  }
}
